import React from 'react';

export const ExpireIcon = props => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_731_3295)">
      <path
        d="M8.9524 0.0419989C8.53335 0.0839987 7.80954 0.245999 7.80954 0.305999C7.80954 0.335999 7.91113 0.485999 8.03811 0.641999C8.16509 0.803999 8.29843 0.989999 8.33652 1.068C8.39367 1.182 8.43176 1.194 8.62859 1.158C9.09843 1.062 10.4826 1.104 10.9524 1.224C11.8921 1.47 12.7048 1.92 13.3714 2.562C15.7905 4.902 15.1683 8.742 12.108 10.344C10.8064 11.022 9.04763 11.106 7.63811 10.548C6.73652 10.194 5.84763 9.522 5.36509 8.82C5.11748 8.466 5.10478 8.454 4.8889 8.49C4.76827 8.508 4.5016 8.544 4.30478 8.562C4.1016 8.58 3.93652 8.604 3.93652 8.622C3.93652 8.676 4.48256 9.486 4.71113 9.768C5.96827 11.31 8.29843 12.198 10.4127 11.94C13.1111 11.61 15.2572 9.762 15.854 7.236C15.9746 6.708 15.9937 5.394 15.8794 4.89C15.1873 1.776 12.2476 -0.282001 8.9524 0.0419989Z"
        fill="#F45A45"
      />
      <path
        d="M2.80017 0.156001C1.93033 0.378001 1.01605 1.014 0.577951 1.704C0.165252 2.358 0.038268 2.772 0.038268 3.54C0.0319188 4.404 0.190649 4.92 0.666839 5.58C2.00017 7.434 4.74303 7.668 6.41287 6.066C7.15573 5.358 7.49224 4.59 7.49224 3.618C7.49224 2.958 7.40335 2.586 7.10493 1.998C6.66049 1.116 5.73986 0.402001 4.72398 0.156001C4.23509 0.0360012 3.26366 0.0360012 2.80017 0.156001ZM4.02557 1.764C4.13986 1.812 4.28589 1.908 4.34303 1.986C4.48906 2.184 4.47636 2.802 4.31128 3.636L4.1716 4.32H3.75255H3.32716L3.25097 3.852C3.20652 3.6 3.14303 3.228 3.10493 3.03C3.0097 2.52 3.06049 2.13 3.24462 1.944C3.50493 1.68 3.69541 1.632 4.02557 1.764ZM4.19065 5.1V5.46H3.7462H3.30176V5.1V4.74H3.7462H4.19065V5.1Z"
        fill="#F45A45"
      />
      <path
        d="M9.49262 2.772C9.34024 2.904 9.32119 2.982 9.11167 4.56C8.99103 5.466 8.90849 6.282 8.92754 6.372C8.95293 6.498 9.25135 6.75 10.191 7.44C10.864 7.932 11.4863 8.364 11.5815 8.4C11.8355 8.49 12.1466 8.334 12.2609 8.058C12.3752 7.764 12.2228 7.59 11.1053 6.774C10.0577 6.012 10.0323 5.982 10.064 5.796C10.1847 5.118 10.4133 3.126 10.3815 3.012C10.2863 2.646 9.81008 2.52 9.49262 2.772Z"
        fill="#F45A45"
      />
    </g>
    <defs>
      <clipPath id="clip0_731_3295">
        <rect width="16" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
